import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'next-share';
import { useEffect, useState } from 'react';

type Props = {
  title: string;
};

const iconSize = 40;

export const BookSocial = ({ title }: Props) => {
  const [pageUrl, setPageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPageUrl(window.location.href);
    }
  }, []);

  return (
    <div className="social flex space-x-3">
      <FacebookShareButton url={pageUrl} quote={title} className="my-3">
        <FacebookIcon
          size={iconSize}
          round
          bgStyle={{ fill: 'rgba(0,0,0,0.05)' }}
          iconFillColor="rgb(0,0,0)"
        />
      </FacebookShareButton>

      <TwitterShareButton url={pageUrl} title={title} className="my-3">
        <TwitterIcon
          size={iconSize}
          round
          bgStyle={{ fill: 'rgba(0,0,0,0.05)' }}
          iconFillColor="rgb(0,0,0)"
        />
      </TwitterShareButton>

      <LinkedinShareButton url={pageUrl} className="my-3">
        <LinkedinIcon
          size={iconSize}
          round
          bgStyle={{ fill: 'rgba(0,0,0,0.05)' }}
          iconFillColor="rgb(0,0,0)"
        />
      </LinkedinShareButton>
    </div>
  );
};
